module.exports = __webpack_public_path__ + "static/media/cardio.17fd0cbd.jpg";